import React from 'react'
import GenericReport from '../GenericReport'

const MostUsedTreatmentsPage: React.FC = () => {
  return <GenericReport reportId={5} />
}

export default MostUsedTreatmentsPage
